export const CREATE_TAX = 'createTax';
export const CREATE_TAXES = 'createTaxes';
export const FETCH_TAX_BY_ID = 'fetchTaxById';
export const FETCH_ORGANIZATION_TAXES = 'fetchOrganizationTaxes';
